import { FC } from 'react';

import cn from 'classnames';

import { LocaleId, useLocale } from 'hooks';
import { useTranslations } from 'context/translations';
import { LandingPageTextKeys } from 'service';

import { IconLanguageClose } from '../icons/IconLanguageClose';
import { IconLanguageMark } from '../icons/IconLanguageMark';
import css from './LocaleModal.module.css';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export const LocaleModal: FC<Props> = ({ isOpen, onClose }) => {
  const { locale, locales, selectLocale } = useLocale();
  const { t } = useTranslations();

  if (!locale) return null;

  return (
    <div className={cn(css.wrapper, isOpen && css.visible)}>
      <div className={css.header}>
        <button type="button" className={css.closeButton} onClick={onClose}>
          <IconLanguageClose />
        </button>
      </div>

      <div className={css.content}>
        <h1>{t(LandingPageTextKeys.LocaleModalTitle)}</h1>
        <div className={css.divider} />
        <div className={css.localeContainer}>
          {Object.entries(locales).map(([key, value]) => (
            <div
              key={key}
              role="presentation"
              onClick={() => selectLocale(key as LocaleId)}
            >
              <IconLanguageMark
                className={!locale.code.startsWith(key) && css.hidden}
              />
              {value.title}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
